import _typeof from "@babel/runtime/helpers/esm/typeof";
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
import React, { Suspense } from 'react';
import PropTypes, { arrayOf } from 'prop-types';
import { StyledHeader, StyledInfo, ShippingAndPickup } from './styles';
import ModalLink from './modal-link';
import ArrivesDate from './arrives-date';
var string = PropTypes.string,
  func = PropTypes.func,
  bool = PropTypes.bool;
var Pickup = /*#__PURE__*/React.lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./pickup'));
  });
});

/**
 * @memberof nr-omni-shipping-pickup
 * @description Renders Estimated Delivery-Date for shipping information and clickable link to update shipping information
 *
 * @param {object} props - react component props
 * @param {Function} props.headerMessage - message describing the information shown (e.g. "Header")
 * @param {Function} props.arrivesMessage - message show if given postal code
 * @param {Function} props.arrivesByMessage - message shown if minimum arrival date and maximum date
 * @param {Function} props.arrivesToMessage - message shown if no minimum arrival date
 * @param {Function} props.editLocationMessage - default call to action to edit location information
 * @param {string} [props.postalCode] - postal code specified for shipping
 * @param {string} [props.minShipDate] - earliest arrival date
 * @param {string} props.maxShipDate - latest arrival date
 * @param {string} props.timeZone - timezone of latest arrival date
 * @param {string} props.language - language sensitive date and time formatting
 * @param {string} props.country - lowercase country for localized font determination
 * @param {Function} props.openModal - callback triggered when user clicks on link
 * @param {Function} props.openPickupModal - callback triggered when user clicks on link - Pickup
 * @param {arrayOf} props.fulfillmentTypes - FF types ['SHIP', 'PICKUP']
 * @param {Function} props.pickupHeaderMessage - message to show Pickup text
 * @param {string} props.minPickupDate - min date input in ISO string format
 * @param {string} props.maxPickupDate - max date input in ISO string format
 * @param {Function} props.pickupUnavailableMessage - message to show unavailable message
 * @param {Function} props.pickupTodayMessage - message to show translated Message for today
 * @param {Function} props.pickupTomorrowMessage - message to show translated Message for tomorrow
 * @param {Function} props.pickupAtMessage - message to show translated Message for At
 * @param {string} props.pickupStoreLocation - pickup store location/name from data
 * @param {string} props.pickupFindStoreMessage - message to show Find a store message in pickup cold state
 * @param {boolean} props.showPickupIneligibleMessage - flag for custom messaging specific to items that will never have pickup available like NBY, giftcards, etc.
 * @param {Function} props.pickupIneligibleMessage - message shown if a product is never available in stock in stores
 * @param {Function} props.learnMoreMessage - message shown to link to more information
 * @returns {React.Component} - react component
 */
function OmniShippingPickup(_ref) {
  var headerMessage = _ref.headerMessage,
    arrivesMessage = _ref.arrivesMessage,
    arrivesByMessage = _ref.arrivesByMessage,
    arrivesToMessage = _ref.arrivesToMessage,
    country = _ref.country,
    editLocationMessage = _ref.editLocationMessage,
    postalCode = _ref.postalCode,
    minShipDate = _ref.minShipDate,
    maxShipDate = _ref.maxShipDate,
    openModal = _ref.openModal,
    timeZone = _ref.timeZone,
    language = _ref.language,
    fulfillmentTypes = _ref.fulfillmentTypes,
    pickupHeaderMessage = _ref.pickupHeaderMessage,
    minPickupDate = _ref.minPickupDate,
    maxPickupDate = _ref.maxPickupDate,
    pickupTodayMessage = _ref.pickupTodayMessage,
    pickupTomorrowMessage = _ref.pickupTomorrowMessage,
    pickupAtMessage = _ref.pickupAtMessage,
    pickupStoreLocation = _ref.pickupStoreLocation,
    openPickupModal = _ref.openPickupModal,
    pickupFindStoreMessage = _ref.pickupFindStoreMessage,
    pickupUnavailableMessage = _ref.pickupUnavailableMessage,
    pickupIneligibleMessage = _ref.pickupIneligibleMessage,
    showPickupIneligibleMessage = _ref.showPickupIneligibleMessage,
    learnMoreMessage = _ref.learnMoreMessage;
  return /*#__PURE__*/React.createElement(ShippingAndPickup, null, fulfillmentTypes.indexOf('SHIP') > -1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledHeader, {
    className: "shipping-pickup header"
  }, headerMessage()), /*#__PURE__*/React.createElement(StyledInfo, {
    country: country
  }, /*#__PURE__*/React.createElement(ArrivesDate, {
    className: "shipping-pickup arrives-date",
    headerMessage: headerMessage,
    arrivesMessage: arrivesMessage,
    arrivesByMessage: arrivesByMessage,
    minShipDate: minShipDate,
    maxShipDate: maxShipDate,
    timeZone: timeZone,
    language: language
  }), /*#__PURE__*/React.createElement(ModalLink, {
    className: "shipping-pickup",
    toOrAtMessage: arrivesToMessage,
    fallbackMessage: editLocationMessage,
    postalCodeOrStoreName: postalCode,
    dataAutomation: "shipping-pickup-link",
    onClick: openModal
  }))), fulfillmentTypes.indexOf('PICKUP') > -1 && /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(Pickup, {
    className: "pickup-container",
    pickupHeaderMessage: pickupHeaderMessage,
    minPickupDate: minPickupDate,
    maxPickupDate: maxPickupDate,
    pickupTodayMessage: pickupTodayMessage,
    pickupTomorrowMessage: pickupTomorrowMessage,
    pickupStoreLocation: pickupStoreLocation,
    pickupAtMessage: pickupAtMessage,
    openPickupModal: openPickupModal,
    pickupFindStoreMessage: pickupFindStoreMessage,
    timeZone: timeZone,
    language: language,
    pickupUnavailableMessage: pickupUnavailableMessage,
    pickupIneligibleMessage: pickupIneligibleMessage,
    showPickupIneligibleMessage: showPickupIneligibleMessage,
    learnMoreMessage: learnMoreMessage
  })));
}
OmniShippingPickup.propTypes = {
  // derived from data returned by service
  timeZone: string,
  minShipDate: string,
  maxShipDate: string,
  minPickupDate: string,
  maxPickupDate: string,
  // functionality driven by nike-shop-client
  openModal: func,
  openPickupModal: func,
  // stored values retrieved by nike-shop-client or derived from data
  fulfillmentTypes: arrayOf(string),
  postalCode: string,
  pickupStoreLocation: string,
  // flag for custom messaging specific to items that will never have pickup available like NBY, giftcards, etc.
  showPickupIneligibleMessage: bool,
  // translations are all functions and end with message
  headerMessage: func,
  arrivesMessage: func,
  arrivesByMessage: func,
  arrivesToMessage: func,
  editLocationMessage: func,
  pickupHeaderMessage: func,
  pickupTodayMessage: func,
  pickupTomorrowMessage: func,
  pickupAtMessage: func,
  pickupFindStoreMessage: func,
  pickupUnavailableMessage: func,
  pickupIneligibleMessage: func,
  learnMoreMessage: func,
  // provided by apps to facilitate localization
  language: string,
  country: string
};
// defaults to show SHIP if there is no fulfillmentTypes
OmniShippingPickup.defaultProps = {
  fulfillmentTypes: ['SHIP']
};
export default OmniShippingPickup;